import { profileStore } from '../stores/profile.js';
import { replace } from './core.js';
import { rootRouteHandler } from './routeHandlers/root.js';
let container;
function getContainer() {
    return document.querySelector('the-app').shadowRoot.querySelector('router-view');
}
let previousPath;
async function processRoute() {
    const { pathname } = location;
    if (pathname === previousPath)
        return;
    previousPath = pathname;
    if (pathname === '/') {
        rootRouteHandler(processRoute);
    }
    else if (pathname === '/sign-in') {
        if (profileStore.isLoggedIn) {
            replace('/my-playlists', processRoute);
            return;
        }
        await import('/src/views/SignInPage.js');
        const $el = document.createElement('sign-in-page');
        container.replaceChildren($el);
    }
    else if (pathname === '/sign-up') {
        if (profileStore.isLoggedIn) {
            replace('/tracks', processRoute);
            return;
        }
        await import('/src/views/SignUpPage.js');
        const $el = document.createElement('sign-up-page');
        container.replaceChildren($el);
    }
    else if (pathname === '/search') {
        if (!profileStore.isLoggedIn) {
            navigation.navigate('/sign-in');
            return;
        }
        await import('/src/views/SearchPage.js');
        const $el = document.createElement('search-page');
        container.replaceChildren($el);
        // /verify/:uuid
    }
    else if (/^\/verify\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathname)) {
        await import('/src/views/VerificationPage.js');
        const pattern = /[a-f\d]{8}(-[a-f\d]{4}){3}-[a-f\d]{12}/i;
        const match = pathname.match(pattern);
        const $el = document.createElement('verification-page');
        $el.verificationToken = match[0];
        container.replaceChildren($el);
    }
    else if (pathname === '/sign-out') {
        profileStore.signOut();
        navigation.navigate('/sign-in');
    }
    else if (pathname === '/restore-password') {
        await import('/src/views/RestorePasswordPage.js');
        const $el = document.createElement('restore-password-page');
        container.replaceChildren($el);
    }
    else if (pathname === '/add-track') {
        if (!profileStore.isLoggedIn) {
            navigation.navigate('/sign-in');
            return;
        }
        await import('/src/views/AddTrackPage.js');
        const $el = document.createElement('add-track-page');
        container.replaceChildren($el);
    }
    else if (pathname === '/my-playlists') {
        if (!profileStore.isLoggedIn) {
            navigation.navigate('/sign-in');
            return;
        }
        await import('/src/views/MyPlaylists.js');
        const $el = document.createElement('my-playlists');
        container.replaceChildren($el);
    }
    else if (pathname === '/playlists/add') {
        if (!profileStore.isLoggedIn) {
            navigation.navigate('/sign-in');
            return;
        }
        await import('/src/views/CreatePlaylist.js');
        const $el = document.createElement('create-playlist');
        container.replaceChildren($el);
    }
    else if (/^\/playlists\/([1-9]\d*)$/.test(pathname)) {
        if (!profileStore.isLoggedIn) {
            navigation.navigate('/sign-in');
            return;
        }
        // Извлекаем ID (первая захваченная группа из регулярки)
        const playlistId = pathname.match(/^\/playlists\/([1-9]\d*)$/)[1];
        await import('/src/views/PlaylistViewPage.js');
        const $el = document.createElement('playlist-view-page');
        // Передаем ID компоненту
        $el.playlistId = playlistId;
        container.replaceChildren($el);
    }
    else {
        await import('/src/views/NotFoundPage.js');
        const $el = document.createElement('not-found-page');
        container.replaceChildren($el);
    }
}
function observeRouting() {
    navigation.addEventListener('navigate', event => {
        event.intercept({
            handler() {
                processRoute();
            }
        });
    });
}
export function initRouting() {
    container = document.querySelector('the-app').shadowRoot.querySelector('router-view');
    ;
    processRoute();
    observeRouting();
}
